/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * A collection of types for price lists
 */
export enum EnumPriceListType {
    /**
     * Base list for prices.
     */
    Base = 0,
    /**
     * Prices specific to the customer (e.g. of an order or invoice).
     */
    Customer = 1,
    /**
     * Prices specific to the site (e.g. of an order).
     */
    Site = 2,
}
